import { Routes } from '@angular/router';
import { LayoutComponent } from 'Admin/layout/layout.component'
import { OAuth2Service } from "@ngxsuit"

export const CHILDROUTES: Routes = [
    {
        path: 'stores/:store_id/cms-mgr', component: LayoutComponent,
        children: [
            {
                "path": "",
                "loadChildren": "CMS/page/cmsmanagement.module#CmsManagementModule",
                canActivate: [OAuth2Service]
            },
        ]
    }
];

export const MENUS = [];

